import { Helper } from "../util/helper.js";
import { BaseComponentProps, BaseField } from "./baseComponentProps.js";
import React from "react";

export class Label extends React.Component<LabelProps, any>{
    private _icuh = Helper;

    render() {
        let content = this.props.value;
        if (typeof this.props.field.isUrl === "boolean" && this.props.field.isUrl) {
            content = <a href={this.props.value} target="_blank">{this.props.value}</a>
        } else if (this._icuh.hasValue(this.props.field.urlTemplate)) {
            let getTemplate = () => {
                return {
                    __html: this._icuh.processTemplate(this.props.field.urlTemplate,
                        (match) => {
                            return this.props.handleEval(match);
                        })
                };
            }

            content = <div dangerouslySetInnerHTML={getTemplate()}></div>;
        } else if (this._icuh.hasValue(this.props.field.textTemplate)) {
            content = this.props.handleEval(this.props.field.textTemplate);
        }

        return (
            <div style={{ marginTop: 10 }}>{content}</div>
        );
    }
};
export interface LabelProps extends BaseComponentProps {
    field: LabelField;
    handleEval?(action: string, prepare?: any);
}


export interface LabelField extends BaseField {
    isUrl?: boolean;
    urlTemplate?: string;
    textTemplate?: string;
}